import React, { useContext, useEffect, useState } from 'react';

import { FilterContext } from '../Context/FilterContext';
import InfoComponent from '../InfoComponent/InfoComponent';
import Modal from '../Modal/Modal';
import Question from './Question/Question';
import SkinCharacteristics from './Question/SkinCharacteristics';
import { StaticResponse } from './StaticResponse';
import Summary from './Summary/Summary';
import { Payload, Questions } from './Types';

import './OnlineAnalysis.scss';

// export const initialPayload: Payload = {
//     ageGroup: 'age1020v',
//     skinColour: 'HF_SH',
//     skinAppearance: 'skinNormalv',
//     skinCharacteristics: [],
//     uvSensitivity: 'UV_05'
// };

export const overlayHash = 'show-online-filter';

export const initialPayload: Payload = {
    ageGroup: null,
    skinColour: null,
    skinAppearance: null,
    skinCharacteristics: [],
    uvSensitivity: null,
};

const OnlineAnalysis: React.FunctionComponent = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [payload, setPayload] = useState<Payload>(initialPayload);
    const [questions, setQuestions] = useState<Questions | null>(null);

    const { isOnlineAnalysisOverlayVisible, makeOnlineAnalysisOverlayVisible } = useContext(FilterContext);

    useEffect(() => {
        setQuestions(StaticResponse);

        if (window.location.hash === '#' + overlayHash) {
            makeOnlineAnalysisOverlayVisible(true);
            window.location.hash = '';
        }
    }, []);

    if (questions === null) {
        return null;
    }

    return (
        <Modal
            visible={isOnlineAnalysisOverlayVisible}
            toggleVisibility={() => makeOnlineAnalysisOverlayVisible(false)}
            centerHorizontally={true}
        >
            <div className="online-analysis">
                <header className="online-analysis__header">
                    <h1 className="online-analysis__headline">Online-Hautbild-Analyse</h1>
                    <InfoComponent
                        title="Online Hautbild Analyse"
                        text={window.__GGOnlineAnalysisInfoText}
                        nested={true}
                    />
                </header>

                {currentPage <= 5 ? (
                    <div className="online-analysis__progress">
                        <strong className="online-analysis__progress-heading">Frage {currentPage} von 5</strong>
                        <div className="online-analysis__progress-bar">
                            <span style={{ width: (100 / 5) * currentPage + '%' }} />
                        </div>
                    </div>
                ) : null}

                <Question
                    page={1}
                    question={questions.ageGroup}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    payload={payload}
                    setPayload={setPayload}
                />
                <Question
                    page={2}
                    question={questions.skinColour}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    payload={payload}
                    setPayload={setPayload}
                />
                <Question
                    page={3}
                    question={questions.uvSensitivity}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    payload={payload}
                    setPayload={setPayload}
                />
                <Question
                    page={4}
                    question={questions.skinAppearance}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    payload={payload}
                    setPayload={setPayload}
                />
                <SkinCharacteristics
                    page={5}
                    question={questions.skinCharacteristics}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    payload={payload}
                    setPayload={setPayload}
                />
                <Summary
                    page={6}
                    currentPage={currentPage}
                    payload={payload}
                    setPayload={setPayload}
                    questions={questions}
                    setCurrentPage={setCurrentPage}
                />
            </div>
        </Modal>
    );
};

export default OnlineAnalysis;
